import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import zh from './zh'
import en from './en'
import hk from './hk'
import jp from './jp'
import es from './es'
import kr from './kr'
import fr from './fr'
import de from './de'
import ita from './ita'
let locale = window.localStorage.getItem('locale') || '';
if(locale == ''){
  locale = 'en';
  window.localStorage.setItem('locale','en');
}
export default new VueI18n({
  locale:locale,
  messages:{
    zh: zh,
    en: en,
    hk: hk,
    jp: jp,
	es: es,
	kr: kr,
	fr: fr,
	de: de,
	ita: ita
  }
})



// WEBPACK FOOTER //
// ./src/lang/lang.js